import { Box, Flex, Image, Skeleton, Text } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { Draggable, Droppable } from 'react-beautiful-dnd';

interface Props {
  display: any;
}

const DisplayCard: React.FC<Props> = ({ display }) => {
  const [loading, setLoading] = useState(true);
  const [img, setImg] = useState<any | null>(null);

  useEffect(() => {
    setLoading(true);
    import(`../../../../assets/${display.preview}`)
      .then(image => {
        setImg(image);
        setLoading(false);
      })
      .catch(() => {
        // prevent from crashing
      })
      .finally(() => setLoading(false));
  }, [display]);

  return (
    <Flex
      bg="white"
      p={4}
      border="2px solid #F0F0F0"
      borderRadius="6px"
      flexDir="column"
      ml="10px"
      mt="10px"
      w="100%"
    >
      {/* <Flex mb={4} align="center">
        <Text color="gray.500" fontWeight="bold" fontSize="sm" mr={2}>
          {display?.name}
        </Text>

        <Tooltip label={display?.description}>
          <span>
            <Icon w={5} h={5} as={AiFillInfoCircle} color="brand.500" />
          </span>
        </Tooltip>
      </Flex> */}
      {loading ? (
        <Skeleton w="100%" h="150px" alignSelf="center" />
      ) : (
        <Droppable isDropDisabled droppableId={display?.id}>
          {droppableProvided => (
            <Box
              ref={droppableProvided.innerRef}
              {...droppableProvided.droppableProps}
            >
              <Draggable draggableId={display?.id} index={0}>
                {provided => (
                  <Flex
                    w="full"
                    draggable
                    ref={provided.innerRef}
                    gridGap={2}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                  >
                    <Image
                      borderRadius="6px"
                      w="50px"
                      h="50"
                      src={img?.default}
                    />
                    <Flex direction="column">
                      <Text color="gray.700" fontWeight="bold" fontSize="sm">
                        {display?.name}
                      </Text>
                      <Text color="gray.500" fontSize="xs">
                        {display?.description}
                      </Text>
                    </Flex>
                  </Flex>
                )}
              </Draggable>

              {droppableProvided.placeholder}
            </Box>
          )}
        </Droppable>
      )}
    </Flex>
  );
};

export default DisplayCard;
